



































import Vue from 'vue';
import BuildingBtnIcon from '@/components/partials/navigationIconMenu/partials/icons/BuildingBtnIcon.vue';
import InfoBtnIcon from '@/components/partials/navigationIconMenu/partials/icons/InfoBtnIcon.vue';
import ScenesBtnIcon from '@/components/partials/navigationIconMenu/partials/icons/ScenesBtnIcon.vue';
import ScheduleBtnIcon from '@/components/partials/navigationIconMenu/partials/icons/ScheduleBtnIcon.vue';
import RhythmsBtnIcon from '@/components/partials/navigationIconMenu/partials/icons/RhythmsBtnIcon.vue';
import SettingsBtnIcon from '@/components/partials/navigationIconMenu/partials/icons/SettingsBtnIcon.vue';
import FaqBtnIcon from '@/components/partials/navigationIconMenu/partials/icons/FaqBtnIcon.vue';

export default Vue.extend({
  name: 'NavigationMenu',
  components: {
    BuildingBtnIcon,
    InfoBtnIcon,
    ScenesBtnIcon,
    ScheduleBtnIcon,
    RhythmsBtnIcon,
    SettingsBtnIcon,
    FaqBtnIcon,
  },
});
